/**
 * Topic buttons — the buddy lists the parts of a chapter (or sub-topics) and
 * the student taps one to be taught exactly that part next.
 */
import { useState } from 'react';
import { Check, ChevronRight } from 'lucide-react';

export function TopicChips({ topics = [], messageId, disabled, onPick }) {
  const [picked, setPicked] = useState([]);
  if (!topics.length) return null;
  const pick = (t) => {
    setPicked(p => (p.includes(t) ? p : [...p, t]));
    onPick(t);
  };
  return (
    <div className="mt-3 pt-3 border-t border-slate-200/70" data-testid={`chat-topics-${messageId}`}>
      <p className="text-[10px] uppercase tracking-wider font-heading text-slate-400 mb-2">Tap a topic to learn it</p>
      <div className="flex flex-wrap gap-2">
        {topics.map((t, i) => {
          const done = picked.includes(t);
          return (
            <button key={t} type="button" disabled={disabled}
              data-testid={`chat-topic-btn-${messageId}-${i}`}
              onClick={() => pick(t)}
              className={`group inline-flex items-center gap-1.5 pl-2 pr-3 py-1.5 rounded-full border text-xs font-heading transition-colors duration-200 disabled:opacity-50 ${done
                ? 'bg-emerald-50 border-emerald-200 text-emerald-700'
                : 'bg-white border-blue-200 text-blue-700 hover:bg-blue-600 hover:border-blue-600 hover:text-white'}`}>
              <span className={`inline-flex items-center justify-center w-4 h-4 rounded-full text-[10px] font-bold ${done ? 'bg-emerald-100' : 'bg-blue-50 text-blue-700 group-hover:bg-white/20 group-hover:text-white'}`}>
                {done ? <Check className="w-3 h-3" /> : i + 1}
              </span>
              {t}
              <ChevronRight className="w-3.5 h-3.5 transition-transform duration-200 group-hover:translate-x-0.5" />
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default TopicChips;
